<template>
  <div class="custom-control custom-checkbox"
       :class="{'disabled': disabled, 'form-check-inline': inline}">
    <input :id="cbId"
           class="custom-control-input"
           type="checkbox"
           :disabled="disabled"
           @click="onChange"
           v-model="model"/>
    <label :for="cbId" class="custom-control-label">
      <slot>
        <span v-if="inline">&nbsp;</span>
      </slot>
    </label>
  </div>
</template>
<script>
import { randomString } from "./stringUtils";
import swal from 'sweetalert2'

export default {
  name: "confirmation-checkbox",
  model: {
    prop: "checked",
    event: 'change'
  },
  props: {
    checked: {
      type: [Array, Boolean],
      description: "Whether checkbox is checked"
    },
    disabled: {
      type: Boolean,
      description: "Whether checkbox is disabled"
    },
    inline: {
      type: Boolean,
      description: "Whether checkbox is inline"
    },
    confirmationMessage: {
      type: String,
      description: "Confirmation dialog message"
    }
  },
  data() {
    return {
      cbId: "",
      touched: false
    };
  },
  methods: {
      onChange(event) {
        event.preventDefault();
        var that = this;
        swal.fire({
                    title: "Are you sure?",
                    text: this.confirmationMessage,
                    type: "warning",
                    icon: "warning",
                    showCancelButton: !0,
                    confirmButtonColor: "#0CC27E",
                    cancelButtonColor: "#FF586B",
                    confirmButtonText: "Confirm",
                    cancelButtonText: "Cancel",
                    confirmButtonClass: "btn btn-success mr-5",
                    cancelButtonClass: "btn btn-danger",
                    buttonsStyling: !1
                }).then(function (result) {
                    if (result.value) {
                      that.$emit("change", !that.checked);
                    }
                }, function (t) {
                    "cancel" === t // Cancelled
                });
      }
  },
  computed: {
    model: {
      get() {
        return this.checked;
      },
      set(check) {
        if (!this.touched) {
          this.touched = true;
        }
        this.$emit("input", check);
      }
    }
  },
  mounted() {
    this.cbId = randomString()
  }
};
</script>
